// cassie doc: https://developer.trustcassie.com/docs/cookie-banner-events

// Define supported full language–country codes
const supportedLangs = ['fr-FR', 'de-DE', 'es-ES', 'it-IT', 'nl-NL', 'cz-CZ', 'zh-CN'];
const isUAT = false; // Change to true for UAT environment
var preferencesConsentChannelId = '45';
var analyticsConsentChannelId = '46';
var marketingConsentChannelId = '49';

if (isUAT) {
  preferencesConsentChannelId = '55';
  analyticsConsentChannelId = '56';
  marketingConsentChannelId = '59';
}

function parseConsent(consent) {
  let marketingAccepted = false;
  let preferencesAccepted = false;
  let analyticsAccepted = false;

  for (var i = 0; i < consent.length; i++) {
    if (consent[i].isOptIn) {
      if (consent[i].channelId === preferencesConsentChannelId) {
        preferencesAccepted = consent[i].isOptIn;
      }
      if (consent[i].channelId === analyticsConsentChannelId && consent[i].isOptIn) {
        analyticsAccepted = consent[i].isOptIn;
      }
      if (consent[i].channelId === marketingConsentChannelId && consent[i].isOptIn) {
        marketingAccepted = consent[i].isOptIn;
      }
    }
  }

  return { marketingAccepted, preferencesAccepted, analyticsAccepted };
}

function getRootDomain(url) {
  try {
    var domain = new URL(url).hostname;
    var elems = domain.split(".");
    var iMax = elems.length - 1;
    var isSecondLevel =
      elems.length >= 3 && (elems[iMax] + elems[iMax - 1]).length <= 5;
    return elems.splice(isSecondLevel ? -3 : -2).join(".");
  } catch (error) {
    return null;
  }
}

function loadScript(src, onSuccess, onError) {
  var script = document.createElement("script");
  script.src = src;
  script.onload = function () {
    if (onSuccess) onSuccess();
  };
  script.onerror = function () {
    if (onError) onError();
  };
  document.head.appendChild(script);
}

function initCassieWidget() {
  let documentLang = (document.documentElement.lang || 'en').toLowerCase();
  let country = window.storeCountryCode || 'US';

  if (country === 'hk') {
    country = 'CN';
  }

  if (documentLang === 'cs') {
    documentLang = 'cz';
  }
  if (documentLang === 'zh-tw') {
    documentLang = 'zh';
  }

  if (documentLang === 'es') {
    country = 'ES';
  }

  let languageCode = `${documentLang}-${country.toUpperCase()}`;

  if (!supportedLangs.includes(languageCode)) {
    languageCode = "";
  }

  if (isUAT) {
    var cassieSettings = {
      widgetProfileId: 3,
      languageCode: languageCode,
      licenseKey: "2FF49355-2054-4241-8DE7-D76346A3F800",
      region: "irl",
      environment: "uat",
      crossDomainConsent: false,
    };
  } else {
    var cassieSettings = {
      widgetProfileId: 1,
      languageCode,
      licenseKey: "0DD43B3E-7C80-4A2D-9F6B-88E70909CEF7",
      region: "irl",
      environment: "production",
      crossDomainConsent: false,
    };
  }

  window.CassieWidgetLoader = new CassieWidgetLoaderModule(cassieSettings);

  document.documentElement.style.setProperty(
    "--prebanner-background-color",
    "#fff"
  );
  document.documentElement.style.setProperty("--banner-background-color", "#fff");

  function addCustomFooter() {
    const footerExtra = document.querySelector(".cassie-cookie-modal--footer-extra");
    if (!footerExtra || footerExtra.querySelector(".cassie-custom-back-button")) {
      return;
    }

    const backButton = document.createElement("button");
    backButton.className = "cassie-custom-back-button";
    backButton.textContent = "Zpět";
    backButton.onclick = function () {
      window.CassieWidgetLoader.Widget.showBanner();
    }

    footerExtra.prepend(backButton);
  }

  document.addEventListener('CassieModalVisibility', function (e) {
    var visible = e.detail; // Returns true or false
    if (visible) {
      addCustomFooter();
    }
  });

  /** Map Cassie's consents to Shopify's consents */
  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    error => {
      if (error) throw error;
    },
  );
  document.addEventListener('CassieSubmittedConsent', function (e) {
    var consent = CassieWidgetLoader.Widget.getCurrentConsent();
    const { marketingAccepted, preferencesAccepted, analyticsAccepted } = parseConsent(consent);

    window.Shopify.customerPrivacy.setTrackingConsent(
      {
        "preferences": preferencesAccepted,
        "analytics": analyticsAccepted,
        "marketing": marketingAccepted,
      }
    );

    // Insider doNotTrack integration
    if (!preferencesAccepted) {
      window.insiderFlow = 1;
    } else {
      window.insiderFlow = 3;
    }

    // Hubspot doNotTrack integration
    const _hsq = window._hsq = window._hsq || [];
    if (!marketingAccepted) {
      _hsq.push(['doNotTrack']);
    } else {
      _hsq.push(['doNotTrack', { track: true }]);
    }

    if (marketingAccepted) {
      dataLayer.push({ 'event': 'cookie_consent_marketing' });
    }
    if (analyticsAccepted) {
      dataLayer.push({ 'event': 'cookie_consent_statistics' });
    }
    if (preferencesAccepted) {
      dataLayer.push({ 'event': 'cookie_consent_preferences' });
    }

    dataLayer.push({
      "event": "cookie_consent_update",
      'cookie_consent_marketing': marketingAccepted ? 'granted' : 'denied',
      'cookie_consent_statistics': analyticsAccepted ? 'granted' : 'denied',
      'cookie_consent_preferences': preferencesAccepted ? 'granted' : 'denied',
      'cookie_consent_necessary': 'granted'
    });

  });

  document.addEventListener('CassieTemplateInitialized', function () {
    if (CassieWidgetLoader.Widget.hasConsent()) {
      var consent = CassieWidgetLoader.Widget.getCurrentConsent();
      const { marketingAccepted, preferencesAccepted, analyticsAccepted } = parseConsent(consent);

      if (analyticsAccepted) {
        dataLayer.push({ 'event': 'cookie_consent_statistics' });
      }
      if (marketingAccepted) {
        dataLayer.push({ 'event': 'cookie_consent_marketing' });
      }
      if (preferencesAccepted) {
        dataLayer.push({ 'event': 'cookie_consent_preferences' });
      }

      dataLayer.push({
        'event': 'cookie_consent_update',
        'cookie_consent_marketing': marketingAccepted ? 'granted' : 'denied',
        'cookie_consent_statistics': analyticsAccepted ? 'granted' : 'denied',
        'cookie_consent_preferences': preferencesAccepted ? 'granted' : 'denied',
        'cookie_consent_necessary': 'granted'
      });
    }
  });

}

function loadScriptWithFallback() {
  var rootDomain = getRootDomain(window.location.href);
  if (isUAT) {
    var fallbackUrl = "https://cscript-cdn-irl-uat.cassiecloud.com/loader.js";
    var scriptUrl = rootDomain
      ? "https://cscript-cdn-irl-uat." + rootDomain + "/loader.js"
      : "https://cscript-cdn-irl-uat.cassiecloud.com/loader.js";
  } else {
    var fallbackUrl = "https://cscript-cdn-irl.cassiecloud.com/loader.js";
    var scriptUrl = rootDomain
      ? "https://cscript-cdn-irl." + rootDomain + "/loader.js"
      : "https://cscript-cdn-irl.cassiecloud.com/loader.js";
  }
  loadScript(
    scriptUrl,
    function () {
      window.cassieResourceRootDomain = rootDomain;
      initCassieWidget();
    },
    function () {
      loadScript(
        fallbackUrl,
        function () {
          initCassieWidget();
        }
      );
    }
  );
}

loadScriptWithFallback();